import React from 'react';
import { Stack, Typography } from '@mui/material';
import { INameValue } from './interfaces';

export const KeyValue: React.FC<INameValue> = ({
  label,
  value,
}): JSX.Element => {
  return (
    <Stack>
      <Typography variant="body2">{label}:</Typography>
      <Typography variant="body2" fontWeight="bold">
        {value}
      </Typography>
    </Stack>
  );
};
